import DemoStore from './DemoStore'
import AccountStore from './AccountStore'
import MyBetsStore from './MyBetsStore'
import LayoutTemplateStore from './LayoutTemplateStore'
import SportsStore from './SportsStore';
import OddspageStore from './OddspageStore';
import SportsMenuStore from './SportsMenuStore';
import BetslipStore from './BetslipStore';
import CasinoStore from './CasinoStore';
import FilterBarStore from './FilterBarStore';
import StatementStore from './StatementStore';
import PromotionStore from './PromotionStore';
import CustomFilterStore from './CustomFilterStore';
import LeaderboardStore from './LeaderboardStore';
import DigitalSportsTechIntegrationStore from './DigitalSportsTechIntegrationStore';
import NewBetslipStore from './NewBetslipStore';
import EsportsLiveStore from './EsportsLiveStore';

export const initStore = () => ({
  DemoStore: new DemoStore(),
  AccountStore: new AccountStore(),
  MyBetsStore: new MyBetsStore(),
  LayoutTemplateStore: new LayoutTemplateStore(),
  SportsStore: new SportsStore(),
  OddspageStore: new OddspageStore(),
  SportsMenuStore: new SportsMenuStore(),
  BetslipStore: new BetslipStore(),
  CasinoStore: new CasinoStore(),
  FilterBarStore: new FilterBarStore(),
  StatementStore: new StatementStore(),
  PromotionStore: new PromotionStore(),
  CustomFilterStore: new CustomFilterStore(),
  LeaderboardStore: new LeaderboardStore(),
  DSTStore: new DigitalSportsTechIntegrationStore(),
  NewBetslipStore: new NewBetslipStore(),
  EsportsLiveStore: new EsportsLiveStore(),
})

let instanceStores
export const getInstanceStores = () => {
  if (!instanceStores) {
    instanceStores = initStore()
  }
  return instanceStores
}



// WEBPACK FOOTER //
// ./src/app/stores/Store.js